function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cm)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.9039 146.784L52.8551 164.934L30.6577 171.64L29.0523 141.007L51.2497 134.301L51.9039 146.784Z",
  fill: "#E3D7FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.5303 153.728C39.8624 153.711 40.1174 153.428 40.1 153.096C40.0826 152.764 39.7993 152.509 39.4673 152.526C39.1353 152.543 38.8803 152.827 38.8977 153.159C38.9151 153.491 39.1983 153.746 39.5303 153.728Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.7647 153.244C49.0967 153.227 49.3518 152.944 49.3344 152.612C49.317 152.28 49.0337 152.025 48.7017 152.042C48.3697 152.059 48.1146 152.343 48.132 152.675C48.1494 153.007 48.4327 153.262 48.7647 153.244Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.2118 156.371L45.7263 147.106L50.3679 146.863",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.0688 147.507L42.7104 147.264",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.1464 152.631L31.315 155.848C30.4815 155.892 29.6648 155.603 29.0446 155.044C28.4243 154.486 28.0513 153.704 28.0076 152.87C28.0024 152.77 27.9976 152.678 28.0056 152.583C28.038 152.185 28.2205 151.814 28.5163 151.545C28.8121 151.277 29.1989 151.13 29.5983 151.137C29.9978 151.143 30.38 151.3 30.6675 151.578C30.9549 151.855 31.1261 152.232 31.1464 152.631V152.631Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.315 155.848C30.4815 155.892 29.6648 155.603 29.0446 155.044C28.4243 154.486 28.0513 153.704 28.0076 152.87",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.3013 158.761C43.4578 158.805 42.6314 158.513 42.0037 157.947C41.376 157.382 40.9984 156.591 40.954 155.748",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.8551 164.934L30.6577 171.64",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.2123 156.379L44.2082 156.985",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.0321 201.7L81.6058 250.808L12.9391 271.547L10.073 216.858C9.57935 207.436 12.2593 198.119 17.6845 190.399C23.1096 182.679 30.9665 177.001 39.9992 174.272V174.272C44.3987 172.943 49.0428 172.632 53.5803 173.362C58.1177 174.093 62.4297 175.845 66.19 178.487C69.9503 181.13 73.0605 184.593 75.2854 188.614C77.5102 192.635 78.7914 197.11 79.0321 201.7V201.7Z",
  fill: "#EE5998"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.8389 151.286C28.8389 151.286 25.2913 141.432 29.8441 137.048C34.397 132.665 55.5426 132.619 55.5426 132.619C55.5426 132.619 57.793 147.167 35.8835 144.808C35.8835 144.808 35.7804 148.878 32.2119 149.783",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.081 180.759C27.081 180.759 -3.56956 202.779 5.2523 257.594C14.0742 312.408 91.5285 238.352 93.5227 233.145C95.517 227.939 86.8165 224.145 76.6677 230.624C76.6677 230.624 80.7204 226.843 78.7168 226.465C76.7133 226.087 72.7519 227.712 70.7679 232.35L22.1093 243.969",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.9654 227.462L127.947 224.895L146.823 174.113",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.5313 180.31C68.5313 180.31 86.7774 195.808 93.5533 226.697",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.771 225.428C117.771 225.428 107.174 261.332 92.9121 265.555C78.6505 269.778 64.6861 259.589 64.6861 259.589",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.2728 226.45C98.2728 226.45 103.964 217.579 107.927 215.387C111.89 213.196 124.418 217.073 122.977 219.274C121.536 221.474 118.649 220.492 118.649 220.492C118.649 220.492 119.467 222.575 118.224 223.207",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.691 25.608C64.7625 25.608 70.495 19.8755 70.495 12.804C70.495 5.73255 64.7625 0 57.691 0C50.6196 0 44.887 5.73255 44.887 12.804C44.887 19.8755 50.6196 25.608 57.691 25.608Z",
  fill: "#E3D7FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.375 3.396C67.8417 4.75758 68.9687 6.44411 69.6655 8.32017C70.3623 10.1962 70.6095 12.2095 70.3873 14.1984C70.165 16.1873 69.4795 18.0964 68.3857 19.7724C67.292 21.4483 65.8205 22.8445 64.0894 23.8487C62.3583 24.8529 60.4159 25.4373 58.4181 25.5548C56.4202 25.6723 54.4227 25.3197 52.5858 24.5254C50.7489 23.731 49.1239 22.517 47.8412 20.9808C46.5585 19.4447 45.6539 17.6291 45.2 15.68",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.553 17.679C53.2434 17.679 53.803 17.1194 53.803 16.429C53.803 15.7387 53.2434 15.179 52.553 15.179C51.8627 15.179 51.303 15.7387 51.303 16.429C51.303 17.1194 51.8627 17.679 52.553 17.679Z",
  fill: "#131313",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.713 14.217C58.5437 14.217 59.217 13.5436 59.217 12.713C59.217 11.8823 58.5437 11.209 57.713 11.209C56.8824 11.209 56.209 11.8823 56.209 12.713C56.209 13.5436 56.8824 14.217 57.713 14.217Z",
  fill: "#131313",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.553 10.319C52.9976 10.319 53.358 9.95857 53.358 9.51398C53.358 9.0694 52.9976 8.70898 52.553 8.70898C52.1085 8.70898 51.748 9.0694 51.748 9.51398C51.748 9.95857 52.1085 10.319 52.553 10.319Z",
  fill: "#131313",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.467 8.54503C60.0723 8.54503 60.563 8.05433 60.563 7.44903C60.563 6.84372 60.0723 6.35303 59.467 6.35303C58.8617 6.35303 58.371 6.84372 58.371 7.44903C58.371 8.05433 58.8617 8.54503 59.467 8.54503Z",
  fill: "#131313",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.334 19.255C58.8117 19.255 59.199 18.8678 59.199 18.39C59.199 17.9123 58.8117 17.525 58.334 17.525C57.8563 17.525 57.469 17.9123 57.469 18.39C57.469 18.8678 57.8563 19.255 58.334 19.255Z",
  fill: "#131313",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.872 16.503C63.5397 16.503 64.081 15.9617 64.081 15.294C64.081 14.6263 63.5397 14.085 62.872 14.085C62.2043 14.085 61.663 14.6263 61.663 15.294C61.663 15.9617 62.2043 16.503 62.872 16.503Z",
  fill: "#131313",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.255 9.90601L56.422 11.939",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.06 13.387L61.688 14.844",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.371 11.36L59.305 8.53101",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.5981 13.725L53.6281 15.796",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.713 14.22L58.333 17.525",
  stroke: "#131313",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.1397 79.4146C70.6149 78.883 73.1921 79.0974 75.5454 80.0306C77.8987 80.9638 79.9225 82.5738 81.3608 84.6572C82.7991 86.7405 83.5873 89.2036 83.6257 91.7349C83.6641 94.2662 82.9511 96.7521 81.5767 98.8781C80.2024 101.004 78.2284 102.675 75.9045 103.679C73.5806 104.683 71.0111 104.976 68.5209 104.52C66.0308 104.064 63.7318 102.879 61.9147 101.117C60.0976 99.3539 58.844 97.0919 58.3125 94.6167C57.5997 91.2976 58.2347 87.8313 60.0776 84.9804C61.9206 82.1294 64.8206 80.1273 68.1397 79.4146V79.4146Z",
  fill: "#FFD5E7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.318 102.953C62.595 101.932 61.1356 100.521 60.0573 98.833C58.9789 97.1452 58.3117 95.228 58.1092 93.2354C57.9067 91.2428 58.1747 89.2305 58.8915 87.3603C59.6083 85.4901 60.754 83.8142 62.2365 82.4674C63.7189 81.1206 65.4967 80.1405 67.4268 79.6059C69.357 79.0712 71.3857 78.997 73.3498 79.3892C75.3139 79.7813 77.1586 80.6289 78.7354 81.8637C80.3123 83.0986 81.5774 84.6863 82.429 86.4991",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.8932 95.3882L66.807 85.302L64.6341 87.475L74.7202 97.5611L76.8932 95.3882Z",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.385 85.879L66.824 86.44",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.184 86.678L67.376 87.483",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.98 87.473L68.419 88.037",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.778 88.272L68.97 89.077",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.574 89.068L70.013 89.632",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.156 91.649L72.595 92.213",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.942 92.436L73.137 93.241",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.728 93.222L74.164 93.783",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.511 94.005L74.706 94.813",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.298 94.792L75.737 95.353",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.724 87.401L67.012 97.113L65.07 97.373L65.308 95.399L74.895 85.813C74.9288 85.7623 74.9677 85.715 75.011 85.672C75.2455 85.486 75.5403 85.3926 75.8392 85.4098C76.1381 85.4269 76.4202 85.5534 76.6319 85.7651C76.8436 85.9768 76.9701 86.2589 76.9873 86.5578C77.0044 86.8567 76.9111 87.1515 76.725 87.386L76.724 87.401Z",
  fill: "#FFD5E7",
  stroke: "#131313",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.324 95.399L67.024 97.099L65.069 97.372L65.324 95.399Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.586 87.526L74.885 85.817C74.9916 85.6819 75.1257 85.571 75.2784 85.4915C75.4311 85.4121 75.5989 85.366 75.7708 85.3562C75.9426 85.3465 76.1146 85.3733 76.2753 85.435C76.436 85.4967 76.5818 85.5918 76.703 85.714C76.8242 85.8362 76.9181 85.9827 76.9784 86.1439C77.0388 86.3051 77.0642 86.4773 77.0531 86.6491C77.0419 86.8208 76.9944 86.9883 76.9137 87.1403C76.833 87.2923 76.721 87.4255 76.585 87.531L76.586 87.526Z",
  fill: "#131313"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cm"
}, /*#__PURE__*/React.createElement("rect", {
  width: 150.109,
  height: 279.248,
  fill: "white"
})));

var SvgCodeMan = function SvgCodeMan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 280,
    viewBox: "0 0 151 280",
    fill: "none",
    className: "sm:hidden absolute bottom-0 left-0 mb-35 -ml-4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCodeMan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/codeMan.3647a1d3.svg";
export { ForwardRef as ReactComponent };